import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { HELP_DOCUMENT_API } from "./apiRoutes";

interface getProps {
  audience: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}
const getHelpDocumentByAudience = async (audience: string) =>
  await axiosAuth.get(`${HELP_DOCUMENT_API}/by-audience?audience=${audience}`);

const useGetHelpDocumentByAudience = ({
    audience,
    queryParams
  }: getProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["help-document-by-audience", audience],
    queryFn: () => getHelpDocumentByAudience(audience),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetHelpDocumentByAudience;
